import { useTranslation } from 'libs/i18n';
import { Section } from 'modules/client/common/components';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {
  title?: string;
}

export const RoleInCompanySection = ({ title, ...formProps }: Props) => {
  const { t } = useTranslation();

  return (
    <Section
      datax="roleInCompanySection"
      title={
        title || t('client.legalRepresentative.roleInCompany.title.physical')
      }
    >
      <FormContent {...formProps} />
    </Section>
  );
};
